// extracted by mini-css-extract-plugin
module.exports = {"seoHeading":"Dp6Zx","seoSubHeading":"TN6YB"};